import {Map, OrderedMap} from 'immutable';
import {bufferToBlob} from '@webex/react-component-utils';

export const FETCH_SHARE = 'share/FETCH_SHARE';
export const RECEIVE_SHARE = 'share/RECEIVE_SHARE';

export const initialState = new Map({
  files: new OrderedMap({})
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_SHARE: {
      const {
        file,
        fileObject
      } = action.payload;
      const {blob, objectUrl} = bufferToBlob(file);
      const key = fileObject.url;

      return state.setIn(['files', key], new Map({
        name: fileObject.displayName,
        mimeType: fileObject.mimeType,
        fileSize: fileObject.fileSize,
        isFetching: false,
        blob,
        objectUrl
      }));
    }

    case FETCH_SHARE: {
      const key = action.payload.fileObject.url;

      return state.setIn(['files', key, 'isFetching'], true);
    }

    default: {
      return state;
    }
  }
}

function fetchShare(fileObject) {
  return {
    type: FETCH_SHARE,
    payload: {
      fileObject
    }
  };
}

function receiveShare(payload) {
  return {
    type: RECEIVE_SHARE,
    payload
  };
}

export function retrieveSharedFile(fileObject, spark) {
  return (dispatch) => {
    dispatch(fetchShare(fileObject));

    return spark.internal.conversation.download(fileObject)
      .then((file) => {
        dispatch(receiveShare({file, fileObject}, false));

        return file;
      });
  };
}
